<script lang="ts">
  import { tooltip } from "app/actions/tooltip";
  import { formatDistanceStrict } from "date-fns";

  export let time: Date | string = "";
  export let modified: Date | string = "";
  export let showEdited: boolean = false;
  export let fontClasses: string = "text-xs font-normal text-neutral-500 dark:text-neutral-400";
  export let full: boolean = true;

  let interval: string = "";
  const EDIT_GRACE_PERIOD_SECONDS = 10;

  // only show modified when we have both times and they differ
  let isModified = false;
  if (time && modified) {
    const from = new Date(time).getTime();
    const to = new Date(modified).getTime();
    const seconds = (to - from) / 1000;
    isModified = seconds > EDIT_GRACE_PERIOD_SECONDS;
  }
  if (time) {
    interval = formatDistanceStrict(new Date(time), new Date(), {
      addSuffix: true,
    });
    // formats the time e.g. '7d ago' - takes first letter of middle timeIntervalWord
    // unless it's months which displays 'mo' to avoid confusion with minutes 'm'
    const [amount, unit, ago] = interval.split(" ");
    interval =
      amount + (unit.startsWith("month") ? "mo" : unit[0].charAt(0)) + " " + (full ? ago : "");
  }
</script>

{#if interval}
  <span
    class="flex shrink-0 {fontClasses}"
    use:tooltip
    title={`${new Date(time).toLocaleDateString("default", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    })}`}
  >
    {#if isModified && showEdited}
      (edited)
    {/if}
    {interval}
  </span>
{/if}
